<template>
    <div :class="classList">
        <div class="find-dealership--sidebar-list">
            <div class="find-dealership-title">
                <h2>Find a distributor</h2>
            </div>
            <div class="find-dealership-list">
                <div class="dealership-list--items">
                    <div class="dealership-list--container active" ref="National">
                        <div class="dealership-list--container-content">
                            <div 
                                class="dealership-list--container-title"
                                @click="toggleActiveDealershipList('National')"
                            >
                                National
                                <span></span>
                            </div>
                            <div class="dealership-list--container-more">
                                <ul>
                                    <li
                                        v-for="company in nationalCompanies"
                                        @click="setActiveItem('National', company)"
                                    >
                                    {{ company.Title }}<span>({{ company.Distributors.length }})</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="dealership-list--container active" ref="Regions">
                            <div 
                                class="dealership-list--container-title"
                                @click="toggleActiveDealershipList('Regions')"
                            >
                                Regions
                                <span></span>
                            </div>
                            <div class="dealership-list--container-more">
                                <ul>
                                    <li
                                        v-for="region in regions"
                                        @click="setActiveItem('Regions', region)"
                                    >
                                    {{ region.Title }}<span>({{ region.Distributors.length }})</span>
                                    </li>
                                </ul>
                            </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="find-dealership--sidebar-list">
            <div 
                v-if="activeItem"
                class="find-dealership-title"
                @click="goBack"
            >
                <div class="find-distributor-title__container">
                    <p class="find-dealership-group">
                        <Chevron />
                        {{ activeGroup }}
                    </p>
                    <h3>{{ activeItem.Title }}</h3>
                </div>
            </div>
            <div v-if="activeItem" class="find-dealership-list">
                <div class="dealership-list--items">
                    <div 
                        :key="distributor.ID" 
                        v-for="distributor in activeItem.Distributors" 
                        class="distributor-item"
                    >
                        <div class="dealership-list--container" @click="triggerMap(distributor)">
                            <div class="distributor-content">
                                <p class="distributor__title">{{ distributor.Title }}</p>
                                <p class="distributor__region">
                                    <MapPin />
                                    <div class="distributor__region-content">
                                        <p class="distributor__region-address">{{ distributor.Address }}</p>
                                        <p class="distributor__region-title">{{ distributor.Suburb }}, {{ distributor.City }}</p>
                                        <p class="distributor__region-postcode">{{ distributor.Postcode }}</p>
                                        <p class="distributor__region-phone"><a :href="`tel:${distributor.Phone}`">{{ distributor.Phone }}</a></p>
                                        <p class="distributor__region-website"><a :href="distributor.Website" target="_blank">Visit Website</a></p>
                                        <p class="distributor__region-directions"><a :href="`https://www.google.com/maps/dir//${distributor.Address}, ${distributor.Region}`" target="_blank">Get Directions</a></p>
                                    </div>
                                </p>
                            </div>
                            <span class="distributor__more">More Info</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import MapPin from './MapPin'
import Chevron from './Chevron'

export default {
    components: {
        MapPin,
        Chevron
    },
    mounted() {
        this.$bus.on('updateMap', this.updateMap);
    },
    data() {
        return {
            groups: this.data.reverse(), // Sneaky way to make sure national is first
            nationalCompanies: this.data.find(group => group.Title === 'National').Companies,
            regions: this.data.find(group => group.Title === 'Regions').Regions,
            activeItem: undefined,
            activeGroup: undefined
        }
    },
    computed: {
        classList() {
            const classes = ['find-dealership--sidebar']
            if (this.activeItem !== null && this.activeItem !== undefined) {
                classes.push('show-active-region')
            }
            return classes.join(' ')
        }
    },
    methods: {
        updateMap(data) {
            this.toggleActiveDealershipList(data.group, data.company.distributors)
            this.setActiveItem(data.group, data.company)
            this.$bus.emit('zoomMap')
        },
        goBack() {
            this.activeItem = null
            this.activeGroup = null
            this.$bus.emit('zoomMap')
        },
        toggleActiveDealershipList(target, distributors = []) {

            Array.from(document.querySelectorAll('.dealership-list--container')).forEach(c => {
                if(this.$refs[target] !== c) {
                    c.classList.remove('active')
                }
            })

            this.$refs[target].classList.toggle('active')

            if (target === 'National') {
                this.nationalCompanies.map(company => {
                    distributors.push(Array.from(company.Distributors))
                }).flat()
                this.activeGroup = 'National'
            }

            if (target === 'Regions') {
                Object.keys(this.regions).map(region => {
                    distributors.push(Array.from(this.regions[region].Distributors))
                }).flat()
                this.activeGroup = 'Regions'
            }

            this.$bus.emit('updateDistributors', distributors.flat())
        },
        setActiveItem(group, item) {
            this.activeGroup = group 
            this.activeItem = item
            this.$bus.emit('updateDistributors', item.Distributors)

            if (group === 'Regions') {
                let zoom = 10

                if (item.Title === 'Otago' || item.Title === 'Caterbury') {
                    zoom = 8
                }

                this.$bus.emit('zoomMap', { zoom, latlng: item.LatLng })
            }
        },
        triggerMap(distributor) {
            this.$bus.emit('showInfo', distributor)
        }
    }
}
</script>
